/**
 * External Dependencies
 */
import 'jquery';
import { closeStrip, stickyHeader, submenuMobile } from './functions/Header'
import { darkMode, selectAutoWidth, fix100vw, langSwith, beforeafter, linkAnchors, notificationBell } from './functions/Utility'
import { createAnchors, monitorAnchors, scrollAnchors, scrollProgress, shareLinks } from './functions/Navigation'
import { heroSliderBuilder } from './functions/Hero';
import { sliderInit } from './functions/Slider'
import { gridInit } from './functions/Grid'
import { loading } from './functions/Animations'
import { tabInit } from './functions/Tabs'
import { flipCardInit } from './functions/Card'
import { checkFavourites, favouriteButtons, favouritesPanel } from './functions/Favourites'
import { searchPanel, launchSearch } from './functions/Search'
import { newsletterForm } from './functions/Newsletter'
import { groupFaq } from './functions/Faq'
import { animatedWords } from './functions/Title'
import { langBanner } from './functions/Lang'
import { contactModal, contactInit } from './functions/Contact'

$(document).ready(() => {
  closeStrip()
  darkMode()
  heroSliderBuilder() //must be before stickyHeader (IntersectionObserver)
  stickyHeader()
  createAnchors()
  monitorAnchors()
  scrollAnchors()
  scrollProgress()
  sliderInit()
  loading()
  tabInit()
  submenuMobile()
  flipCardInit()
  gridInit()
  selectAutoWidth()
  checkFavourites()
  favouriteButtons()
  favouritesPanel()
  searchPanel()
  launchSearch()
  newsletterForm()
  shareLinks()
  langSwith()
  groupFaq()
  animatedWords()
  langBanner()
  beforeafter()
  contactModal()
  contactInit()
  linkAnchors()
  notificationBell()
});
